var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.large)?_c('v-icon',{staticClass:"v-accordion__caret v-accordion__caret--large",attrs:{"name":"arrow-key-down","size":"small"}}):_c('v-icon',{staticClass:"v-accordion__caret v-accordion__caret--small",attrs:{"name":"arrow-key-down","size":"xsmall"}})
}
var staticRenderFns = []

export { render, staticRenderFns }